module.exports = __webpack_public_path__ + "img/26_15.c1cfa5df.png";